import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { Dimmer, Message } from 'semantic-ui-react';
import { useEvaluated } from '../hooks/useEvaluated';
import { InputType } from '../types';
import { Code } from './Code';
import { Output } from './Output';

export type Args = { inputs: InputType; [key: string]: any };

interface FunctionProps {	
	template: string;
	args: Args;
	onEvaluate: (evalWithLocale: (locale: string) => string) => void;
}

const FastDimmable = styled(Dimmer.Dimmable)`
	& > * {
		transition: 0.2s filter ease !important;
	}
	& .ui.negative.message {
		color: #9f3a38 !important;
	}
`;

export const Function: React.FC<FunctionProps> = ({ template, args, onEvaluate }) => {
	const [code, output, evalWithLocale, error] = useEvaluated(template, args);

	useEffect(() => {
		onEvaluate(evalWithLocale);
	}, [code]);
	
	const dimmed = error !== null;

	return (
		<FastDimmable blurring dimmed={dimmed}>
			<Output callback={output}></Output>
			<Code value={code} />
			<Dimmer inverted active={dimmed} verticalAlign="top">
				<Message negative>{error}</Message>
			</Dimmer>
		</FastDimmable>
	);
};
